<template>
  <AcceptingDialog
    ref="accepting_dialog"
    :acceptors="acceptors"
    :card_text="cardText"
    :close="closeDialog"
    :first-btn="isPublished ? 'Common.Clearly' : 'Common.ThankYou'"
    :load_acceptors="load_agreement"
    :submit="closeDialog"
    :title="title"
    :without_accept="!acceptors.length">
    <template #activator>
      <DialogTemplateToolkit
        class="comment-tender-agreement"
        :dialog="comment_dialog"
        :disabled="innerLoading || publishing || load_agreement"
        first_btn="Catalog.Send"
        :loading="innerLoading || publishing || load_agreement"
        :title="$t('Tenders.AddCommentForAgreement')"
        @apply="sendTenderWithValidate"
        @close="() => comment_dialog = false">
        <template #activator-btn>
          <sTooltip
            :content="typeof disabled === 'boolean' ? '' : disabled"
            :disabled="!disabled || (typeof disabled === 'boolean' && disabled)"
            placement="top"
            trigger="hover"
            width="200">
            <sButton
              data-qa="btn-send-tender-dialog"
              :disabled="innerLoading || !!disabled"
              :loading="loading || innerLoading || publishing || load_agreement"
              @click="openDialog">
              {{ btnText }}
            </sButton>
          </sTooltip>
        </template>
        <template #card-text>
          <sInput
            class="comment-tender-agreement__input"
            clearable
            data-qa="tender-agreement-comment"
            :placeholder="$t('Tenders.ApprovalComment')"
            show-word-limit
            trim
            type="textarea"
            :value.sync="comment"/>
        </template>
      </DialogTemplateToolkit>
    </template>
    <template #additional_text>
      <div
        v-if="planText"
        class="h6-text black--text mb-7">
        {{ planText }}
        <div
          v-if="tenderPublishedSchedule && tenderPublishedSchedule.previousMailing"
          class="mt-2">
          {{ $t('Tenders.PreviousMailingModalInfo') }}
        </div>
      </div>
    </template>
    <template #accepting_second_btn>
      <ShareBlock
        v-if="tender"
        class="ml-10"
        :options="{
          id: tender.tenderId,
          number: tender.tenderNumber,
          title: tender.title
        }"/>
    </template>
  </AcceptingDialog>
</template>
<script>
import ShareBlock from 'components/tenders/dialogs/ShareBlock'
import AcceptingDialog from 'components/common/dialogs/AcceptingDialog.vue'
import DialogTemplateToolkit from 'components/common/dialogs/DialogTemplateToolkit.vue'

import SmarttenderApi from '@/api/smarttenderApi'
import moment from 'moment'
const api = new SmarttenderApi()

import { mapGetters } from 'vuex'
import { tenderMixin } from 'mixins'
export default {
  name: 'createTenderDialog',
  mixins: [ tenderMixin ],
  data() {
    return {
      customCardTitle: null,
      customCardText: null, // Кастомный текст для модалки (новый ответ бека при публикации)
      dialog: false,
      innerLoading: false,
      publishing: false,
      publish: true,
      load_agreement: false,
      acceptors: [],
      tariff: 0,
      comment_dialog: false,
      comment: ''
    }
  },
  methods: {
    async sendTenderWithValidate() {
      if (!this.validateFn && typeof this.validateFn !== 'function') {
        this.sendTender()
      } else {
        this.validateFn().then(() => {
          this.sendTender()
        })
      }
    },
    async sendTender() {
      let ret
      this.$emit('open')
      this.publishing = true
      this.$store.commit('setNewTenderInfo', {...this.info, loading: true })
      let action = this.action || this.tender.biddingType.isFrameAuction
      let oldModeResult = true
      try {
        if (!this.tariff) {
          api.informManagers()
          this.$Modal.info({
            title: this.$t('Tenders.ThankYouForTheCreatedTender'),
            content: this.$t('Tenders.WaitForManagerCallToCompletePublication'),
            okText: this.$t('Common.ThankYou'),
            onOk: this.closeDialog
          })
        } else if (this.has_required_agreement && !this.has_required_agreement.onStart) { // todo additional agreement
          if (!this.info.acceptors?.length || this.info.acceptors.some(el => el.status == 'DECLINE')) {
            this.load_agreement = true
            ret = await api.startTenderAgree({tenderId: this.tender.tenderId, comment: this.comment})
            if (ret) {
              this.load_agreement = false
              this.acceptors = ret
            }
          } else {
            return this.$router.push({name: 'tenderitem', params: {org: this.$route.params.org, id: this.tender.tenderId} })
          }
        } else if (action) {
          const model = {}
          const key = `copyAllBids_${this.tender.tenderId}`
          if (this.$can('is', 'copyQualifiedBidsToAuction')) {
            model.copyBidsToAuction = !!this.$_getPropFromLocalStorage(key, 1, true)
          }
          await api.fillAuctionData(this.tender.tenderId, {
            finishDate: this.tender.tenderPeriodTo,
            prolongationRule: this.tender.prolongRuleCode || null,
            deliveryPeriod: {
              startDate: this.tender.deliveryPeriodFrom,
              endDate: this.tender.deliveryPeriodTo,
            },
            bidStepType: this.tender.bidStepType ? 'ABSOLUTE' : 'PERCENT',
            lots: this.tender.lots?.map(lot => ({
              lotId: lot.lotId,
              startAmount: lot.startAmount,
              bidStep: lot.bidStep,
            }))
          })
            .then(async fillAuctionResult => {
              if (fillAuctionResult) {
                ret = await api.changeToAuction(this.tender.tenderId, model)
                if (this.$can('is', 'copyQualifiedBidsToAuction')) {
                  this.$_deletePropFromLocalStorage(key, true)
                }
              }
            })
        } else if (this.isRegistration) {
          if (this.tender.biddingType?.withoutPublication) {
            ret = await api['tenderWithdrawal'](this.tender.tenderId, '')
          } else {
            let request
            if (this.plan) {
              request = 'tenderSchedule'
            } else {
              request = 'publishTender'
              oldModeResult = false
            }
            ret = await api[request](this.tender.tenderId)
          }
        }
        if (oldModeResult) {
          if (ret && (this.has_required_agreement || action || this.plan || JSON.parse(ret).Success)) {
            if (this.$refs.accepting_dialog) {
              this.$refs.accepting_dialog.open()
            } else {
              this.$log('errrorred', this.$route)
            }
          }
        } else {
          if (ret) {
            if (ret?.data?.publishTender) {
              this.$refs.accepting_dialog.open()
            } else {
              let customTitle = `${this.$t('Tenders.Tender')} #${this.tender?.tenderNumber || '–'} ${this.$t('Catalog.WasCreated')}`
              const customText = ret.extensions.messages?.length ? (this.$t(ret.extensions.messages[0]) || '') : ''
              this.$Modal.info({
                title: customTitle,
                content: customText,
                okText: this.$t('Common.Clearly'),
                onOk: () => {
                  window.location.href = `${this.baseUrl}/${this.langPrefix}${this.$route.params.org}/tenders/${this.tender.tenderId}`
                  //this.$router.push({name: 'tenderitem', params: {id: this.tender.tenderId, org: this.$route.params.org} })
                }
              })
            }
          } else {
            this.$log('errrorred', this.$route)
          }
        }
      } finally {
        this.load_agreement = false
        this.publishing = false
        this.$_savePropToLocalStorage(`criteria.${this.tender.tenderId}`, null, true)
        this.$store.commit('setNewTenderInfo', {...this.info, loading: false })
      }
    },
    openDialog() {
      if (this.show_comment_dialog) {
        this.comment_dialog = true
      } else {
        this.sendTenderWithValidate()
      }
    },
    closeDialog() {
      this.$refs.accepting_dialog.closeDialog(true)
      if (this.action) {
        this.$emit('update:action', false)
        this.$root.$emit('tenderUpdate', true)
      } else {
        window.location.href = `${this.baseUrl}/${this.langPrefix}${this.$route.params.org}/tenders/${this.tender.tenderId}`
      }
    },
  },
  computed: {
    ...mapGetters({
      settings: 'getSettings',
      info: 'getNewTenderInfo',
      survey: 'getSurveyData'
    }),
    isRegistration() {
      return (this.tender?.tenderStatus?.id || this.tender?.tenderStatusId) == 1
    },
    plan() {
      return this.isRegistration && this.tenderPublishedSchedule
    },
    tenderPublishedSchedule() {
      return this.tenderSchedule || this.tender?.tenderPublishedSchedule
    },
    show_comment_dialog() {
      return this.tariff && this.has_required_agreement && !this.has_required_agreement.onStart
    },
    btnText() {
      if (this.tender.biddingType?.withoutPublication) {
        return this.$t('Common.Add')
      }
      if ((this.tariff && this.isPublished && !this.plan) || this.innerLoading) {
        return this.$t('Tenders.Publish')
      }
      if (!this.tariff) {
        return this.$t('Common.Add')
      }
      if (this.plan) {
        return this.$t('Tenders.ToSchedule')
      }
      return this.$t('Catalog.Send')
    },
    title() {
      let tender = this.$t('Tenders.Tender') + ' #' + (this.tender?.tenderNumber || '–')

      let afterText = !this.plan && this.isPublished && !this.tender.biddingType?.withoutPublication
        ? this.$t('Tenders.Published')
        : this.isRegistration ? this.$t('Catalog.WasCreated') : this.$t('Tenders.SentForApproval')

      if (this.customCardTitle) {
        afterText = this.customCardTitle
      }

      return `${tender} ${afterText}`
    },
    cardText() {
      if (this.customCardText) {
        return this.customCardText
      }
      return !this.plan && this.isPublished
        ? this.$t('Tenders.PublishedText')
        : this.$t('Tenders.CreateTendeerText')
    },
    isPublished() {
      return !this.has_required_agreement || this.has_required_agreement.onStart
    },
    planText() {
      if (this.plan) {
        return this.$t('Tenders.PublicationScheduled',
          {date: this.plan.scheduledDate ? moment(this.plan.scheduledDate).format('DD.MM.YYYY HH:mm') : ''})
      }
      return null
    },
    langPrefix() {
      return this.$i18n.locale === 'uk' ? '' : 'en/'
    }
  },
  created() {
    this.innerLoading = true
    this.$store.dispatch('getContractNumberAndTariff')
      .then(res => {
        this.tariff = res?.tariff
        this.innerLoading = false
      })
  },
  components: {
    ShareBlock,
    AcceptingDialog,
    DialogTemplateToolkit
  },
  props: {
    tender: Object,
    /**
     * Или текст с причиной блокировки или булевый признак
     */
    disabled: [Boolean, String],
    loading: Boolean,
    action: Boolean,
    validateFn: Function,
    tenderSchedule: Object,
  },
}
</script>
